// extracted by mini-css-extract-plugin
export default {"boundaryHeader":"MapCompound_boundaryHeader__5Z3GM","address":"MapCompound_address__BlnNv","tMargin":"MapCompound_tMargin__EAlYj","map":"MapCompound_map__RxbTI"};